<template>
  <div
    class="menu-componet"
    @mouseover="isMobile || open()"
    @mouseout="isMobile || hide()"
    @click="isMobile && change()">
    <template v-if="childs && childs.length > 0">
      <div class="h-layout">
        <router-link class="a" :to="link" :class="{active: show}">
          <i @click.stop="toLink">{{text}}</i>
        </router-link>
        <span>‹</span>
      </div>

      <div
        v-if="childs" class="child"
        v-show="show"
        @click.stop="toLink">

        <router-link :to="item.link" class="a" v-for="(item, key) in childs" :key="key">
          <i>{{item.text}}</i>
        </router-link>
      </div>
    </template>
    <template v-else>
      <div  @click.stop="toLink">
        <router-link class="a h-layout" :to="link" :class="{active: show}">
          <i>{{text}}</i>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import browser from '@/util/browser'

export default {
  name: 'Menu',
  props: ['text', 'link', 'childs', 'show'],
  data () {
    return {
      isMobile: browser.mobile
    }
  },
  methods: {
    toLink () {
      this.$emit('tolink')
    },
    change () {
      console.log('???')
      this.$emit('change')
    },
    open () {
      this.$emit('open')
    },
    hide () {
      this.$emit('hide')
    }
  }
}
</script>

<style scoped>
  .menu-componet {
    position: relative;
    display: inline-block;
  }

  .h-layout {
    padding-top: 20px;
    padding-bottom: 20px;
    display: block;
  }

  .child > .a {
    display: block;
    padding: 20px 0;
  }

  .a{
    color: #fff;
    transition: color .3s linear;
  }

  .a:hover {
    color: #18ade9;
  }

  .menu-componet > .a.active {
    color: #18ade9;
  }

  .menu-componet span {
    transform: rotateZ(-90deg);
    position: absolute;
    top: 30px;
    right: 25px;
    margin-top: -12px;
    transition: transform linear .3s;
    font-size: 25px;
    font-weight: 100;
  }

  .menu-componet .a.active + span {
    transform: rotateZ(90deg)
  }

  .child {
    overflow: hidden;
    padding-left: 20px;
  }

  @media screen and (min-width: 1220px) {
    .child {
      padding-left: 0;
      overflow: hidden;
      width: auto;
      position: absolute;
      left: 0;
      top: 100%;
      box-sizing: border-box;
      min-width: 100%;
      margin-top: -1px;
    }

    .child > .a {
      background-color: #1a1a1a;
      text-align: left;
      padding-left: 40px;
      padding-right: 40px;
      white-space: nowrap;
    }

    .h-layout  {
      padding: 0
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/index.vue